import React, { useEffect, useState, useContext } from 'react';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { Row, Col, Spinner, Alert } from 'react-bootstrap';
import { CancelButton } from 'uiwidgets/CancelButton';
import PageContentContainer from 'uiwidgets/PageContentContainer';
import { extractError } from 'api/ErrorUtil';
import { API } from 'api/API';
import { BUSINESS_MESSAGES_URL } from 'config/config';
import { TenantContext } from '../../tenant/TenantContext';
import { containsAlphaNumAndSpaceAndPunctuationOnly, isEmailAddressValid } from 'util/Validators';
import { isPasswordStrong } from "../../util/Validators";
import { PasswordField } from 'uiwidgets/PasswordField';
import { useNavigate } from 'react-router-dom';
import { BUSINESS_ADMIN_RESET_PASSWORD } from 'config/config';

const BusinessResetPassword = () => {

    const navigate = useNavigate();

    const initialState = {
        errors: {},
        infoMessage: "",
        readOnly: false
    }
    const initialValidationState = {
        emailError: false,
        emailErrMsg: "",
        passwordError: false,
        passwordErrMsg: ""
    }

    const messageReset = () => {
        return {
            infoMessage: "",
            errors: {}
        }
    }

    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }

    const [formData, setFormData] = useState(initialState);
    const [formValidityData, setFormValidityData] = useState(initialValidationState);
    const { businessConfig } = useContext(TenantContext);

    const handleChange = (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;
        setFormData({
            ...formData,
            [name]: value
        })

    }

    const handleValidation = (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "email":
                if (value.trim() === "") {
                    hasError = true
                    error = "Email cannot be empty"
                } else if (!isEmailAddressValid(value)) {
                    hasError = true
                    error = "Invalid Email"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "password":
                if (value.trim() === "") {
                    hasError = true;
                    error = "New Password cannot be empty";
                } else if (isPasswordStrong(value) === false) {
                    hasError = true;
                    error = "You must use a strong password";
                }
                else {
                    hasError = false;
                    error = "";
                }

                break
            default:
                break;
        }
        return { hasError, error };
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        const tagNames = ['input'];
        for (let tagName of tagNames) {
            //validate full form
            for (let i = 0; i < event.target.getElementsByTagName(tagName).length; i++) {
                let fieldName = event.target.getElementsByTagName(tagName)[i].name;
                let fieldValue = event.target.getElementsByTagName(tagName)[i].value;
                let valResult = validateInput(fieldName, fieldValue);
                setFormValidityData({
                    ...formValidityData,
                    [fieldName + 'Error']: valResult.hasError,
                    [fieldName + 'ErrMsg']: valResult.error
                })
                if (valResult.hasError) {
                    alert("Form has validation error")
                    return false;
                }
            }
        }

        try {
            let response = await API.put(BUSINESS_ADMIN_RESET_PASSWORD,{
                email: formData.email,
                password: formData.password
            });
            setFormData({
                ...formData,
                ...response.data,
                infoMessage: "Password was reset successfully. please try to login before giving the password to the user and advise them to change it.",
                errors: {}
            });
        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                infoMessage: "",
                errors: exError
            });
        }
    }

    return (
        <FormContainer title="Password Reset" submitButtonFunction={handleSubmit}
            errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
            <Row>
                <Col mb={8} lg={8} sm={12}>
                    <FormField name="email" label="User's email address" type="text"
                        value={formData.email}
                        placeholder="User's email address" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.emailError} valMsg={formValidityData.emailErrMsg}
                        readOnly={formData.readOnly} />
                </Col>
            </Row>

            <Row>
                <Col mb={8} lg={8} sm={12}>
                    <PasswordField name="password" label="New Password" value={formData['password']}
                        placeholder="Enter New Password" onChange={handleChange} onBlur={handleValidation}
                        valstate={!formValidityData.passwordError} valMsg={formValidityData.passwordErrMsg} />
                </Col>
            </Row>
            <Row>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col>
                    <SubmitButton label='Submit' />&nbsp;&nbsp;&nbsp;
                    <CancelButton label='Cancel' onClick={(event) => { navigate(-1) }} />
                </Col>
            </Row>
        </FormContainer>
    )
}

export default BusinessResetPassword